import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { adminApi, errorText } from "@/lib/adminApi";
import { GlobeMark } from "@/components/site/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    adminApi.get("/auth/me", { signal: controller.signal })
      .then(() => { if (!controller.signal.aborted) nav("/admin", { replace: true }); })
      .catch(() => {});
    return () => controller.abort();
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await adminApi.post("/auth/login", { email, password });
      nav("/admin", { replace: true });
    } catch (err) {
      setError(errorText(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#082F24] grain relative grid place-items-center px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="relative w-full max-w-sm rounded-3xl bg-[#FAF8F5] p-8">
        <GlobeMark className="h-12 w-12" />
        <h1 className="mt-6 font-display text-4xl text-[#082F24]">Enquiry inbox</h1>
        <p className="mt-2 text-sm text-[#52635B] flex items-center gap-2"><Lock className="h-4 w-4" />Admin access only</p>
        <div className="mt-8 space-y-5">
          <div className="space-y-2"><Label htmlFor="em">Email</Label><Input id="em" type="email" required data-testid="admin-login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-white" /></div>
          <div className="space-y-2"><Label htmlFor="pw">Password</Label><Input id="pw" type="password" required data-testid="admin-login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-white" /></div>
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-700">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-btn" className="mt-6 w-full inline-flex justify-center items-center gap-2 rounded-full bg-[#082F24] py-3.5 text-sm font-semibold text-[#FAF8F5] hover:bg-[#0F5A47] transition-colors disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}Sign in
        </button>
      </form>
    </div>
  );
}
